import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { server } from "./server";
import axios from "axios";
import { toast } from "react-toastify";
const AuthContext = createContext({});
export const Authentication = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(true);

  const changeMenuSize = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const verifyToken = localStorage.getItem("token");

    if (verifyToken) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${verifyToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${server}/auth/profile`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          if (result) {
            setUser(JSON.parse(result).data);
            setToken(localStorage.getItem("token"));
          } else {
            setUser(null);
          }
          setLoadingInitial(false);
        })
        .catch((error) => {
          console.log("error", error);
          toast.error(error?.message || "Something went wrong!");
          setLoadingInitial(false);
        });
    } else {
      setLoadingInitial(false);
    }
  }, []);

  const loginWithEmailAndPassword = async (email, password) => {
    setLoading(true);
    try {
      const payload = { username: email, password };
      const { data } = await axios.post(`${server}/auth/login`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      setUser(data?.data || null);
      if (data?.token) {
        localStorage.setItem("token", data.token);
        setToken(data.token);
      }
    } catch (e) {
      const msg = e?.response?.data?.message || e?.response?.data || e?.message;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (updatedData) => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token");
      const { data } = await axios.put(`${server}/auth/profile`, updatedData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (data?.data) {
        setUser(data.data);
        toast.success("Profile updated successfully");
      }
      return data;
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data || err?.message;
      toast.error(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async ({ currentPassword, newPassword, username }) => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token");
      const payload = {
        username: username || user?.username,
        currentPassword,
        newPassword,
      };
      const { data } = await axios.put(`${server}/auth/changePassword`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      toast.success(data?.message || "Password changed successfully");
      return data;
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data || err?.message;
      toast.error(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setLoading(true);
    try {
      setUser(null);
      localStorage.clear();
      navigate("/login");
      setLoading(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const memoValues = useMemo(
    () => ({
      user,
      loading,
      updateProfile,
      changePassword,
      loginWithEmailAndPassword,
      logout,
      token,
      menuOpen,
      changeMenuSize,
    }),
    [user, loading, token, menuOpen]
  );
  return (
    <AuthContext.Provider value={memoValues}>
      {!loadingInitial && children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}
